import { render, staticRenderFns } from "./personReg.vue?vue&type=template&id=460f2f02&scoped=true"
import script from "./personReg.vue?vue&type=script&lang=js"
export * from "./personReg.vue?vue&type=script&lang=js"
import style0 from "./personReg.vue?vue&type=style&index=0&id=460f2f02&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460f2f02",
  null
  
)

export default component.exports